/**
 * Invoice PDF template contract (RBAC area: admin-only).
 *
 * Each of the four invoice generation sources has exactly one editable PDF template.
 * A template is a full HTML document containing placeholder tokens that are filled in
 * when an invoice's PDF is rendered:
 *
 *   - `{{token}}`      \u2014 HTML-escaped value substitution.
 *   - `{{{token}}}`    \u2014 raw (unescaped) substitution; used for generated markup such as
 *                         the line-item rows.
 *   - `{{#token}}\u2026{{/token}}` \u2014 a section rendered only when `token` is truthy.
 *
 * Templates are authored by administrators and are therefore trusted to contain arbitrary
 * HTML/CSS. Per-invoice data substituted via `{{token}}` is still escaped.
 */
/** The invoice sources that have an editable PDF template (the four generation modes). */
export const INVOICE_TEMPLATE_SOURCES = [
    'product_subscription',
    'managed_services',
    'project',
    'tickets',
];
/** True when `source` is one that has an editable template. */
export function isInvoiceTemplateSource(source) {
    return INVOICE_TEMPLATE_SOURCES.includes(source);
}
/** The placeholder tokens an invoice template may reference. */
export const INVOICE_TEMPLATE_TOKENS = [
    'companyName',
    'number',
    'statusLabel',
    'typeLabel',
    'customerName',
    'customerEmail',
    'period',
    'issueDate',
    'dueDate',
    'terms',
    'currency',
    'subtotal',
    'total',
    'notes',
    'lineRows',
    'hoursTable',
    'footer',
];
//# sourceMappingURL=invoice-template.js.map